import type { ChangeLogItem } from '~/domain/changelog/store/ChangeLogState';
import { bffWebApi } from './index';

const changeLogAPI = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    getChangeLogItems: build.query<ChangeLogItem[], void>({
      query: () => ({
        url: '/changelog',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetChangeLogItemsQuery } = changeLogAPI;
export default changeLogAPI;
